module.exports = __webpack_public_path__ + "static/media/bg.93fa98b5.png";